import {
  formatMoneyDisplay,
} from './moneyDecimals'

export { formatMoneyDisplay, getDisplayDecimals, roundMoneyDisplay } from './moneyDecimals'

/** Formato monetario homogéneo para UI (2 dec en MXN, catálogo SAT en otras monedas). */
export const formatCurrency = (value, moneda = 'MXN', catalogoMonedas = []) => {
  if (value === null || value === undefined || value === '') {
    return 'N/A'
  }
  return formatMoneyDisplay(value, moneda, catalogoMonedas, { prefix: '$' })
}
